import React from 'react';
import { Button as RCUIButton } from '@saddlebackchurch/react-cm-ui';
import makeStyles from '@saddlebackchurch/react-cm-ui/core/styles/makeStyles';
import classNames from 'classnames';
import { noop } from 'lodash';

type PropTypes = {
    children: React.ReactNode;
    className?: string | null;
    color?: string;
    disabled?: boolean;
    fullWidth?: boolean;
    id?: string | null;
    onClick?: () => void;
    type?: string;
    variant?: string;
    size?: string | null;
};

const useStyles = makeStyles(({
    typography: {
        pxToRem,
    },
}) => ({
    root: {
        paddingTop: pxToRem(18),
        paddingBottom: pxToRem(18),
        '& .button-inner-container': {
            minHeight: 'unset',
            fontSize: pxToRem(16),
            lineHeight: 0.875,
        },
    },
}));

function Button({
    children,
    className = null,
    color = 'primary',
    disabled = false,
    fullWidth = true,
    id,
    onClick = noop,
    type = 'button',
    variant = 'contained',
    size = null,
}: PropTypes) {
    const classes = useStyles({
        color,
        disabled,
    });

    return (
        <RCUIButton
            className={classNames(classes.root, className, color)}
            color={color}
            designVersion={2}
            disabled={disabled}
            fullWidth={fullWidth}
            id={id}
            onClick={onClick}
            size={size}
            tabIndex={0}
            type={type}
            variant={variant}
        >
            {children}
        </RCUIButton>
    );
}

export default Button;
